import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import ApprovalPbfList from "../../components/screen/ApprovalPbf/ApprovalPbfList";

const ApprovalPbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <ApprovalPbfList />
        </ThemeProvider>
      }
      pageRole={3}
      requiredTitle={3} // Apoteker Penanggung Jawab
      bgColor={"gray"}
      header="Approval PBF Purchase"
    />
  );
};

export default HOC(ApprovalPbfPage);
